export const assessmenteMan = { //参与多人考核页
  path: '/assessmenteMan',
  name: 'assessmenteMan',
  component: () => import('@/views/scan/assessmenteMan.vue')
}
export const newsDetail = { //新闻页详情
  path: '/newsDetail',
  name: 'newsDetail',
  component: () => import('@/views/news/newsDetail.vue')
}
export const policyDetail = { //政策页详情
  path: '/policyDetail',
  name: 'policyDetail',
  component: () => import('@/views/policy/policyDetail.vue')
}

//无token政策页
export const policyDetailTwo = { //政策页详情
  path: '/policyDetailTwo',
  name: 'policyDetailTwo',
  component: () => import('@/views/policy/policyDetailNoToken.vue')
}
//通用模块
export const linLongMsg = { //林长信息
  path: '/linLongMsg',
  name: 'linLongMsg',
  component: () => import('@/views/universal/linLongMsg.vue')
}
export const forest = { //林地信息
  path: '/forest',
  name: 'forest',
  component: () => import('@/views/universal/forest.vue')
}
export const oldTree = { //古树信息
  path: '/oldTree',
  name: 'oldTree',
  component: () => import('@/views/universal/oldTree.vue')
}
export const dutyArea = { //责任区信息
  path: '/dutyArea',
  name: 'dutyArea',
  component: () => import('@/views/universal/dutyArea.vue')
}
export const inform = { //通知信息
  path: '/inform',
  name: 'inform',
  component: () => import('@/views/inform/informMsg.vue')
}

//新增/编辑 通知
export const editInform = { //新增/编辑 通知
  path: '/editInform',
  name: 'editInform',
  component: () => import('@/views/inform/editInform.vue')
}

export const billboardMsg = { //公示牌信息
  path: '/billboardMsg',
  name: 'billboardMsg',
  component: () => import('@/views/universal/billboardMsg.vue')
}
export const monitorMsg = { //监测点信息
  path: '/monitorMsg',
  name: 'monitorMsg',
  component: () => import('@/views/universal/monitorMsg.vue')
}
export const findMsg = { //发现信息
  path: '/findMsg',
  name: 'findMsg',
  component: () => import('@/views/universal/findMsg.vue')
}
export const administrativeAreaMsg = { //政区信息
  path: '/administrativeAreaMsg',
  name: 'administrativeAreaMsg',
  component: () => import('@/views/universal/administrativeAreaMsg.vue')
}

export const sthxMsg = { //生态红线信息
  path: '/sthxMsg',
  name: 'sthxMsg',
  component: () => import('@/views/universal/sthxMsg.vue')
}
export const zrbhdMsg = { //自然保护地信息
  path: '/zrbhdMsg',
  name: 'zrbhdMsg',
  component: () => import('@/views/universal/zrbhdMsg.vue')
}
export const wetlandMsg = { //湿地信息
  path: '/wetlandMsg',
  name: 'wetlandMsg',
  component: () => import('@/views/universal/wetlandMsg.vue')
}
export const yzldMsg = { //营造林信息
  path: '/yzldMsg',
  name: 'yzldMsg',
  component: () => import('@/views/universal/yzldMsg.vue')
}
//林长模块
export const information = { //数据信息模块
  path: '/information',
  name: 'information',
  component: () => import('@/views/linLong/information.vue')
}
//林长详情模块
export const linLongDetail = { //林长详情模块
  path: '/linLongDetail',
  name: 'linLongDetail',
  component: () => import('@/views/linLong/linLongDetail.vue')
}
//统计分析
export const statisticAnalyze = { //统计分析详情
  path: '/statisticAnalyze',
  name: 'statisticAnalyze',
  component: () => import('@/views/evaluationMode/assessPage.vue')
}
export const assessPage = { //统计分析主页
  path: '/assessPage',
  name: 'assessPage',
  component: () => import('@/views/evaluationMode/assessPage.vue')
}
//成效模块
export const effect = { //统计分析
  path: '/effect',
  name: 'effect',
  component: () => import('@/views/effect/effectNew.vue')
}
//搜索模块
export const search = { //搜索模块首页
  path: '/search',
  name: 'search',
  component: () => import('@/views/search/search.vue')
}
//放大全屏视频
export const monitorVideo = { //搜索模块首页
  path: '/monitorVideo',
  name: 'monitorVideo',
  component: () => import('@/views/map/monitorVideo.vue')
}

//地图定位页面
export const locator = {
  path: '/locator',
  name: 'locator',
  component: () => import('@/views/map/Locator.vue'),
  meta: {
    title: '查看位置'
  }
}
//任务地图定位页面
export const locatorTask = {
  path: '/locatorTask',
  name: 'locatorTask',
  component: () => import('@/views/map/locatorTask.vue'),
  meta: {
    title: '查看位置'
  }
}
//地图位置选择页面
export const selector = {
  path: '/selector',
  name: 'selector',
  component: () => import('@/views/map/Selector.vue'),
  meta: {
    title: '位置选择'
  }
}
//任务下发位置选择专用页面
export const tdselector = {
  path: '/tdselector',
  name: 'tdselector',
  component: () => import('@/views/map/TaskDownSelector.vue'),
  meta: {
    title: '选择任务位置'
  }
}
//护林页面
export const protector = {
  path: '/protector',
  name: 'protector',
  component: () => import('@/views/map/Protector.vue'),
  meta: {
    title: '护林'
  }
}
//护林页面,半离线
export const protectorOff = {
  path: '/protectorOff',
  name: 'protectorOff',
  component: () => import('@/views/map/protectorOff.vue'),
  meta: {
    title: '护林'
  }
}
//责任区页面
export const zrq = {
  path: '/zrq',
  name: 'zrq',
  component: () => import('@/views/map/Zrq.vue'),
  meta: {
    title: '责任区'
  }
}

//个人
export const oneLOneD = {
  path: '/oneLOneD',
  name: 'oneLOneD',
  component: () => import('@/views/oneLOneD/oneLOneDNew.vue'),
  meta: {
    title: '资源信息'
  }
}

//林长通关于页
export const lztAbout = {
  path: '/lztAbout',
  name: 'lztAbout',
  component: () => import('@/views/about/lztAbout.vue'),
  meta: {
    title: '关于'
  }
}

//东华关于页
export const lztDh = {
  path: '/lztDh',
  name: 'lztDh',
  component: () => import('@/views/about/lztDh.vue'),
  meta: {
    title: '关于我们'
  }
}
//智能生态研究院关于页
export const lztZnsty = {
  path: '/lztZnsty',
  name: 'lztZnsty',
  component: () => import('@/views/about/lztZnsty.vue'),
  meta: {
    title: '关于我们'
  }
}
//用户须知
export const userNotice = {
  path: '/userNotice',
  name: 'userNotice',
  component: () => import('@/views/userNotice/userNotice.vue'),

}
//隐私政策
export const privacyPage = {
  path: '/privacyPage',
  name: 'privacyPage',
  component: () => import('@/views/userNotice/privacyPage.vue'),

}
//工作单详情
export const worksheet = {
  path: '/worksheet',
  name: 'worksheet',
  component: () => import('@/views/worksheet/worksheetDetail.vue'),
  meta: {
    title: '工作单'
  }
}
//编辑/发布工作单
export const editWorksheet = {
  path: '/editWorksheet',
  name: 'editWorksheet',
  component: () => import('@/views/worksheet/editWorksheet.vue'),
  meta: {
    title: '工作单编辑'
  }
}
//改革示范区详情
export const reformarea = { //林地评价搜索
  path: '/reformarea',
  name: 'reformarea',
  component: () => import('@/views/news/reformareaDetail.vue')
}
//护林单
export const hulin = { //护林单
  path: '/hulin',
  name: 'hulin',
  component: () => import('@/views/hulin/hulin.vue')
}

//森林百科古树
//古树列表，Gis地图
export const gushuGis = {
  path: '/gushuGis',
  name: 'gushuGis',
  component: () => import('@/views/oldTree/gushuGis.vue'),
  meta: {
    title: '古树名木保护与修复'
  }
}
//古树详情  ==》古树名木系统
export const gushuDetail = { //古树详情
  path: '/gushuDetail',
  name: 'gushuDetail',
  component: () => import('@/views/oldTree/gushuDetail.vue')
}
//古树详情  ==》新增/编辑古树
export const gushuRecord = { //古树详情
  path: '/gushuRecord',
  name: 'gushuRecord',
  component: () => import('@/views/oldTree/gushuRecord.vue')
}

export const zrqMsg = { //新版责任区（带操作）
  path: '/zrqMsg',
  name: 'zrqMsg',
  component: () => import('@/views/map/zrqBox.vue')
}
export const videoPage = { //视频页
  path: '/videoPage',
  name: 'videoPage',
  component: () => import('@/views/universal/videoPage.vue')
}
export const pubResourceMsg = { //无token责任区显示
  path: '/pubResourceMsg',
  name: 'pubResourceMsg',
  component: () => import('@/views/pub/pubResourceMsg.vue')
}
export const pubZqInfo = { //无token政区显示
  path: '/pubZqInfo',
  name: 'pubZqInfo',
  component: () => import('@/views/pub/pubZqInfo.vue')
}

 

export const gatherPage = { //巡林数据结合页
  path: '/gatherPage',
  name: 'gatherPage',
  component: () => import('@/views/xunlin/xunlinDatum.vue')
}
export const allXunLRank = { //巡林数据排行榜
  path: '/allXunLRank',
  name: 'allXunLRank',
  component: () => import('@/views/xunlin/allXunLRank.vue')
}
export const xunLDetail = { //巡林数据详情页
  path: '/xunLDetail',
  name: 'xunLDetail',
  component: () => import('@/views/xunlin/xunLDetail.vue')
}

//古树统计分析 新版古树名木系统

export const treeAnalyse = { //古树统计分析
  path: '/treeAnalyse',
  name: 'treeAnalyse',
  component: () => import('@/views/oldTree/treeAnalyse.vue')
}
export const gushuManage = { //古树管理
  path: '/gushuManage',
  name: 'gushuManage',
  component: () => import('@/views/oldTree/gushuManageList.vue')
}
export const gushuRepair = { //古树修复记录
  path: '/gushuRepair',
  name: 'gushuRepair',
  component: () => import('@/views/oldTree/gushuRepair.vue')
}

export const routers = [assessmenteMan, newsDetail, policyDetail, policyDetailTwo, linLongMsg, forest, oldTree, dutyArea, inform, editInform, information,
  linLongDetail, search, statisticAnalyze, assessPage, effect, billboardMsg, monitorMsg, findMsg, administrativeAreaMsg, oneLOneD,
  sthxMsg, zrbhdMsg, wetlandMsg, yzldMsg, locator, selector, tdselector, protector, zrq, lztAbout, lztDh, lztZnsty, userNotice,
  worksheet, editWorksheet, reformarea, hulin, privacyPage, gushuGis, gushuDetail, gushuRecord, protectorOff, zrqMsg, videoPage, pubResourceMsg,pubZqInfo, gatherPage, allXunLRank, xunLDetail,
  treeAnalyse, gushuManage, gushuRepair, locatorTask,monitorVideo
]